<template>
  <div class="avatar-container">
    <md-avatar class="dropdown-toggle" :class="`md-${size}`">
      <img
        class="header-img"
        src="/img/favicon2.png"
        alt="Swampum"
        :width="chooseImgSize"
        :height="chooseImgSize"
      />
    </md-avatar>
  </div>
</template>
<script>
import UserHelperVue from "@/mixins/UserHelper.vue";
import GroupHelper from '../../mixins/GroupHelper.vue';

export default {
  name: "SSwampumAvatar",
  mixins: [UserHelperVue, GroupHelper],
  props: ["size", "tryModeratorBadge"],
  methods: {
    chooseImgSize() {
      switch (this.size) {
        case "x-small":
          return "34px";
        case "small":
          return "40px";
        case "medium":
          return "75px";
        case "large":
          return "100px";
        case "x-large":
          return "132px";
        default:
          return "75px";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.md-avatar.md-large {
  width: 100px;
  height: 100px;
  font-size: 64px;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}
.md-avatar.md-medium {
  width: 75px;
  height: 75px;
  font-size: 48px;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}
.md-avatar.md-x-medium {
  width: 40px !important;
  height: 40px !important;
  font-size: 20px;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}
.md-avatar.md-small {
  width: 30px !important;
  height: 30px !important;
  font-size: 20px;
}

.md-avatar.md-x-small {
  min-width: 34px !important;
  width: 34px !important;
  height: 34px !important;
  font-size: 16px;
}
.md-avatar.md-x-large {
  font-size: 72px;
}
.dropdown-toggle::after {
  content: none;
}
.moderator-badge {
  position: absolute;
  right: -9px;
  bottom: -7px;
  margin-right: unset !important;
  min-width: unset !important;
  max-width: unset !important;
  height: unset !important;
  width: unset !important;
}
</style>
